import React, { useEffect, useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Menu, X, ChevronRight, Mail, Phone, MapPin } from 'lucide-react';
import { Button } from './ui/Button';
import { Logo } from './ui/Logo';
import { WhatsAppButton } from './WhatsAppButton';
import { CFA_INFO, SITE_LAST_UPDATED, QUALIOPI_LOGO } from '../data/constants';
const NAV_LINKS = [{
  name: 'Accueil',
  path: '/'
}, {
  name: 'Notre CFA',
  path: '/le-cfa'
}, {
  name: 'Vie étudiante',
  path: '/bde'
}, {
  name: 'CAP 360',
  path: '/candidater#cap-360-section' // Redirige vers la section CAP 360
}, {
  name: 'Formations',
  path: '/formations'
}, {
  name: 'Admissions',
  path: '/candidater'
}, {
  name: 'Entreprises',
  path: '/entreprises'
}, {
  name: 'Qualité & engagements',
  path: '/qualite'
}];
export function Layout() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);
  return <div className="min-h-screen flex flex-col bg-background font-sans" data-id="element-377" data-mp="1rmtg6oze0mhl">
      {/* Header */}
      <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60" data-id="element-378" data-mp="1wlobgqejk3il">
        <div className="container flex h-20 items-center justify-between" data-id="element-379" data-mp="13ucxqdbqmshr">
          <Logo data-id="element-380" data-mp="18tz9sjfty2oz" />

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6" data-id="element-381" data-mp="18t7qa6zibvf2">
            {NAV_LINKS.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors hover:text-primary ${location.pathname === link.path || link.path !== '/' && location.pathname.startsWith(link.path) ? 'text-primary' : 'text-muted-foreground'}`} data-id="element-382" data-mp="1dtvi2uvk8gac">
                {link.name}
              </Link>)}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center gap-3" data-id="element-383" data-mp="29i9jcuc07b5b">
            <Button variant="outline" asChild data-id="element-384" data-mp="29hrh9h2nu2ph">
              <Link to="/entreprises" data-id="element-385" data-mp="24jg6930mpm5o">Recruter un alternant</Link>
            </Button>
            <Button asChild data-id="element-386" data-mp="1gtlu6no4w1mh">
              <Link to="/candidater" data-id="element-387" data-mp="1gsswec75kmgh">Candidater</Link>
            </Button>
          </div>

          {/* Mobile Menu Toggle */}
          <Button variant="ghost" size="icon" aria-label="Menu" className="lg:hidden" onClick={() => setIsMobileMenuOpen(true)} data-id="element-388" data-mp="1bw2gppz9fsvl">
            <Menu className="h-6 w-6" data-id="element-389" data-mp="1lr468mxg6wyp" />
          </Button>
        </div>
      </header>

      {/* Custom Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="fixed inset-0 w-[100vw] min-h-[100dvh] overflow-y-auto isolate lg:hidden" style={{
      backgroundColor: '#FFFFFF',
      opacity: 1,
      zIndex: 99999
    }} data-id="element-390" data-mp="t4jdpj58ketk">
          <div className="flex flex-col min-h-full p-6" data-id="element-391" data-mp="39jo361c3k840">
            {/* Header du menu */}
            <div className="flex items-center justify-between mb-8" data-id="element-392" data-mp="2uuiayxbofi5m">
              <Logo showTagline={false} data-id="element-393" data-mp="2zriep1l208tk" />
              <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(false)} aria-label="Fermer le menu" data-id="element-394" data-mp="2zsjrpblmr5dx">
                <X className="h-8 w-8 text-primary-dark" data-id="element-395" data-mp="3sg633613nebc" />
              </Button>
            </div>

            {/* Liens du menu */}
            <nav className="flex flex-col gap-6 flex-1" data-id="element-396" data-mp="3iihxfl1ygmee">
              {NAV_LINKS.map(link => <Link key={link.name} to={link.path} onClick={() => setIsMobileMenuOpen(false)} className={`text-2xl font-bold font-heading transition-colors hover:text-brand-orange ${location.pathname === link.path || link.path !== '/' && location.pathname.startsWith(link.path) ? 'text-primary' : 'text-primary-dark'}`} data-id="element-397" data-mp="2329ehtfv6pt1">
                  {link.name}
                </Link>)}
            </nav>

            {/* Boutons d'action */}
            <div className="flex flex-col gap-4 mt-12 pb-8" data-id="element-398" data-mp="28n60lh0p8e4y">
              <Button size="lg" variant="outline" className="w-full justify-center border-primary/20 text-primary-dark hover:bg-primary/5 text-lg py-6" asChild onClick={() => setIsMobileMenuOpen(false)} data-id="element-399" data-mp="369d38ldfzweo">
                <Link to="/entreprises" data-id="element-400" data-mp="2sa3z4k2igsr2">Recruter un alternant</Link>
              </Button>
              <Button size="lg" className="w-full justify-center bg-brand-orange hover:bg-[#E67E22] text-white text-lg py-6 shadow-xl" asChild onClick={() => setIsMobileMenuOpen(false)} data-id="element-401" data-mp="1kwae8zf0ib53">
                <Link to="/candidater" data-id="element-402" data-mp="3sjva19w3ekrf">Candidater</Link>
              </Button>
            </div>
          </div>
        </div>}

      {/* Main Content */}
      <main className="flex-1" data-id="element-403" data-mp="5d2o1sw830v0">
        <Outlet data-id="element-404" data-mp="5brok59t8f9p" />
      </main>

      {/* Footer */}
      <footer className="bg-primary-dark text-lavande pt-20 pb-10 border-t-4 border-primary" data-id="element-405" data-mp="a4kqkldw99i3">
        <div className="container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-406" data-mp="f3e3ablcwwh7">
          {/* Identity */}
          <div className="space-y-6" data-id="element-407" data-mp="k15vz7ttsmmg">
            <Logo light className="mb-2" data-id="element-408" data-mp="k4blupaa3sj8" />
            <div className="space-y-2 text-sm text-lavande/80" data-id="element-409" data-mp="o3apm6k9xj93">
              <p className="font-bold text-white" data-id="element-410" data-mp="o1zjw179q1fc">{CFA_INFO.legalName}</p>
              <p data-id="element-411" data-mp="t2dk4x2mo72t">SIRET : {CFA_INFO.siret}</p>
              <p data-id="element-412" data-mp="2pvfaiy3cvgab">UAI : {CFA_INFO.uai}</p>
              <p data-id="element-413" data-mp="2pwgy221k5v8x">NDA : {CFA_INFO.nda}</p>
              <p data-id="element-414" data-mp="2pxjq4dama3qf">Président : {CFA_INFO.president}</p>
            </div>

            {/* Qualiopi certificate */}
            <div className="flex pt-2" data-id="element-415" data-mp="1zry9nibosds">
              <span className="inline-flex items-center justify-center bg-white rounded-xl p-4 shadow-sm" data-id="element-416" data-mp="20l0cb6c6tpl">
                <img src={QUALIOPI_LOGO} alt="Certification Qualiopi — processus certifié, République Française" className="w-44 h-auto object-contain" data-id="element-417" data-mp="3t7nr51i9ixza" />
              </span>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-6" data-id="element-418" data-mp="kx31tkazm7z1">
            <h3 className="font-heading font-bold text-lg text-white" data-id="element-419" data-mp="fzkn1daagyj4">
              Contact
            </h3>
            <ul className="space-y-4 text-sm" data-id="element-420" data-mp="tqprqtsikh0b">
              <li className="flex items-start gap-3" data-id="element-421" data-mp="tqg2x9j7gfw7">
                <div className="w-8 h-8 rounded-full bg-primary/40 flex items-center justify-center shrink-0" data-id="element-422" data-mp="pougoxks6p9c">
                  <MapPin className="w-4 h-4 text-white" data-id="element-423" data-mp="13ocbpuoo6yr5" />
                </div>
                <span className="pt-1.5" data-id="element-424" data-mp="yqattd2zd5h9">{CFA_INFO.address}</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-425" data-mp="yo7uu3juo20e">
                <div className="w-8 h-8 rounded-full bg-primary/40 flex items-center justify-center shrink-0" data-id="element-426" data-mp="1id5lcw7ez769">
                  <Phone className="w-4 h-4 text-white" data-id="element-427" data-mp="1nafaeaqw5gtk" />
                </div>
                <span className="font-medium text-white" data-id="element-428" data-mp="18cmx7p8th4ij">{CFA_INFO.phone}</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-429" data-mp="1dbpx6v9xwkjn">
                <div className="w-8 h-8 rounded-full bg-primary/40 flex items-center justify-center shrink-0" data-id="element-430" data-mp="zlcup8fthy1p">
                  <Mail className="w-4 h-4 text-white" data-id="element-431" data-mp="14bt8wurgpnp4" />
                </div>
                <a href={`mailto:${CFA_INFO.email}`} className="hover:text-white transition-colors font-medium" data-id="element-432" data-mp="14dw8o6if2v71">
                  {CFA_INFO.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Navigation */}
          <div className="space-y-6" data-id="element-433" data-mp="gouvk5yn2vvf">
            <h3 className="font-heading font-bold text-lg text-white" data-id="element-434" data-mp="koc272psxz26">
              Navigation
            </h3>
            <ul className="space-y-3 text-sm font-medium" data-id="element-435" data-mp="112a30l6rb1ny">
              <li data-id="element-436" data-mp="w4rqylxg06bq">
                <Link to="/" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-437" data-mp="w48li4ozbael">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-438" data-mp="r78dho8kjxku" /> Accueil
                </Link>
              </li>
              <li data-id="element-439" data-mp="i4gyxfkecloz">
                <Link to="/le-cfa" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-440" data-mp="i4z2yydaw47g">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-441" data-mp="dc5xg8a0crub" /> Le CFA
                </Link>
              </li>
              <li data-id="element-442" data-mp="3g2zzfq3phdp">
                <Link to="/bde" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-443" data-mp="3gm67z6e2hbw">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-444" data-mp="3unym8avjcoq8" /> Le BDE
                </Link>
              </li>
              <li data-id="element-445" data-mp="262rs9dqqs6v5">
                <Link to="/formations" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-446" data-mp="2639klzaaa0xs">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-447" data-mp="2f36hgo6tu63x" /> Nos
                  formations
                </Link>
              </li>
              <li data-id="element-448" data-mp="2k17zr6wfi1ec">
                <Link to="/candidater" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-449" data-mp="2k1r93z80jhgr">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-450" data-mp="1rcu1qr5cb52s" />{' '}
                  Candidater
                </Link>
              </li>
              <li data-id="element-451" data-mp="1walrbeiiif3t">
                <Link to="/entreprises" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-452" data-mp="213euvz28vheb">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-453" data-mp="13nhqzmud6oyd" /> Espace
                  Entreprises
                </Link>
              </li>
              <li data-id="element-454" data-mp="itvxyyldc0xe">
                <Link to="/contact" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-455" data-mp="islzi8alsqq8">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-456" data-mp="srto5rmsg7sn" /> Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Informations utiles */}
          <div className="space-y-6" data-id="element-457" data-mp="xok1w8b4eraw">
            <h3 className="font-heading font-bold text-lg text-white" data-id="element-458" data-mp="3xjo0qz9blb">
              Informations utiles
            </h3>
            <ul className="space-y-3 text-sm font-medium" data-id="element-459" data-mp="530pvoip1nuv">
              <li data-id="element-460" data-mp="a1lmzf2nfrf3">
                <Link to="/qualite" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-461" data-mp="a129qbny1r7e">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-462" data-mp="3di29mp7oyvk2" /> Qualité
                  & Qualiopi
                </Link>
              </li>
              <li data-id="element-463" data-mp="3ifubaay51w1g">
                <Link to="/accessibilite" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-464" data-mp="3ifau4wgbbboh">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-465" data-mp="1vlgztc8c80e0" />{' '}
                  Accessibilité Handicap
                </Link>
              </li>
              <li data-id="element-466" data-mp="1lm8aiwof39xz">
                <Link to="/reclamations" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-467" data-mp="1lmrfzdwvs5v4">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-468" data-mp="1gozq0pfsqttk" />{' '}
                  Réclamations
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="container pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-lavande/60" data-id="element-469" data-mp="17sqs5f7gw39j">
          <div className="flex flex-col items-center md:items-start gap-1" data-id="element-470" data-mp="xwx6957uyxf3">
            <p className="font-medium" data-id="element-471" data-mp="sxuc4ftf2blw">
              © {new Date().getFullYear()} {CFA_INFO.name}. Tous droits
              réservés.
            </p>
            <p className="text-lavande/50" data-id="element-472" data-mp="j8do5vpt547s">
              Site mis à jour le {SITE_LAST_UPDATED}
            </p>
          </div>
          <div className="flex items-center gap-6 font-medium" data-id="element-473" data-mp="o6oxm5c6xcph">
            <Link to="/mentions-legales" className="hover:text-white transition-colors" data-id="element-474" data-mp="aauvq69u3nlv">
              Mentions légales
            </Link>
            <Link to="/confidentialite" className="hover:text-white transition-colors" data-id="element-475" data-mp="121hjdliobp4i">
              Politique de confidentialité
            </Link>
            <Link to="/cgv" className="hover:text-white transition-colors" data-id="element-476" data-mp="t8xql1p2cerl">
              CGV
            </Link>
          </div>
        </div>
      </footer>

      <WhatsAppButton data-id="element-477" data-mp="x7d9ate430z7" />
    </div>;
}